import AppContainer from './Containers/AppContainer/AppContainer'

export default AppContainer



// WEBPACK FOOTER //
// ./src/modules/App/index.js